// @flow

import { css } from 'styled-components';
import mmHeadline from './fonts/MMHeadlineProWebTT-Regular.woff2';
import mmTextBold from './fonts/MMTextProWebTT-Bold.woff2';
import mmTextRegular from './fonts/MMTextProWebTT-Regular.woff2';

export default css`
  @font-face {
    font-family: 'MM-Headline';
    font-style: normal;
    font-weight: 400;
    src: local('MM-Headline'), url(${mmHeadline}) format('woff2');
  }

  @font-face {
    font-family: 'MM-Text';
    font-style: normal;
    font-weight: 600;
    src: local('MM-TextMedium'), url(${mmTextBold}) format('woff2');
  }

  @font-face {
    font-family: 'MM-Text';
    font-style: normal;
    font-weight: 400;
    src: local('MM-TextRegularItalic'), url(${mmTextRegular}) format('woff2');
  }
`;
